


























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { IPropertyRecordTypeInput } from '@/modules/Property/interfaces/property-form'

@Component({
  components: {
    AppTextSearch
  }
})
export default class PropertyFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IPropertyRecordTypeInput }) value!: IPropertyRecordTypeInput

  mounted () {
    this.getRecordTypes(RecordTypeMaster.PROPERTY)
  }

  recentlyClickHandler (index: number) {
    const recordType = this.recentlyUsedRecordTypes[index]
    this.candidateRecordTypes.push()
    const findIndex = this.candidateRecordTypes.findIndex(rt => rt.name === recordType.name)
    if (findIndex === -1) {
      this.candidateRecordTypes = [...this.candidateRecordTypes, recordType]
    }
    this.value.recordType = {
      id: +recordType.id,
      name: recordType.name
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
